import React, { ChangeEvent } from "react";
import { FormGroup } from "react-bootstrap";
import { CSSProperties } from "styled-components";

import OptionsSelect from "../model/OptionsSelect";
import SelectOption from "../model/SelectOption";
import InputSelectStyles from "../styles/components/InputSelectStyles";
import InputTextStyles from "../styles/components/InputTextStyles";

const { StyledFormSelect, StyledLabel } = InputSelectStyles;

interface InputSelectProps {
    value: string;
    optionsSelect: OptionsSelect[] | SelectOption[];
    label?: string;
    style?: CSSProperties;
    styleFormGroup?: CSSProperties;
    disabled?: boolean;
    floatLabel?: boolean;
    handleSelectChange: (
        event: ChangeEvent<{
            value: unknown;
        }>
    ) => void;
}

function InputSelect({
    value,
    optionsSelect,
    label,
    style,
    styleFormGroup = { marginBottom: "24px", maxWidth: "735px" },
    disabled = false,
    floatLabel = false,
    handleSelectChange,
}: InputSelectProps) {
    const { StyledFloatingLabel } = InputTextStyles;

    const select = (
        <StyledFormSelect
            className="selectpicker"
            aria-label="Default select example"
            value={value}
            onChange={handleSelectChange}
            data-live-search="true"
            disabled={disabled}
            style={style}
        >
            {optionsSelect.map((option: any) => (
                <option
                    key={option.value}
                    value={option.value}
                    style={{ backgroundColor: "#F0F2F2", padding: "20px" }}
                >
                    {option.text || option.label}
                </option>
            ))}
        </StyledFormSelect>
    );

    const inputTextFloat = (
        <StyledFloatingLabel
            controlId="floatingInput"
            label={label}
            className="mb-4"
        >
            {select}
        </StyledFloatingLabel>
    );

    const inputSelect = (
        <>
            {label ? <StyledLabel>{label}</StyledLabel> : null}
            {select}
        </>
    );

    return (
        <FormGroup
            style={styleFormGroup}
            controlId="exampleForm.ControlTextarea1"
        >
            {floatLabel ? inputTextFloat : inputSelect}
        </FormGroup>
    );
}

export default InputSelect;
